import {createReducer, on} from "@ngrx/store";
import * as BuildingsActions from './buildings.actions';
import {Building} from "../../models/Building";
export const BuildingsFeatureKey = 'buildings';
export const BuildingsInitialState: Building[] = null;
export const BuildingsReducer = createReducer<Building[] | null>(
  BuildingsInitialState,
  on(BuildingsActions.update, (_state, { buildings }) => buildings),
);
